/**
 * Exhaustiveness check for discriminated unions. Place at the end of a
 * `switch` over a union type; the compiler errors if a branch is missing.
 */
export function assertNever(value: never): never {
  throw new Error(`Unexpected value: ${JSON.stringify(value)}`);
}
